<template lang="pug">
.grey
  .header-container
    b-container
      b-row
        b-col.mb-5(cols="12" lg="8")
          Message(
            :fontSizes="fontSizes"
            title="Best-in-class business analysis meets computer science expertise"
            subtitle="We think our main value add is the unique capability to combine business analysis best practices with leading data processing and visualization capabilities. This is reflective of the diverse experiences of our multidisciplinary team."
          )
</template>

<script>
import Message from '@/components/Shared/Message.vue'
import Navbar from '@/components/Shared/Navbar.vue'

export default {
  name: 'Header',
  components: {
    Message,
  },
  computed: {
    fontSizes () {
      if (window.innerWidth > 991) {
        return [50, 24, 16]
      } else if (window.innerWidth > 576) {
        return [40, 20, 15]
      } else {
        return [25, 16, 14]
      }
    }
  }
}

</script>

<style scoped lang="scss">

$color-title: #364149;
$color-subtitle: #767F86;

.header-container{
  background: url("../../assets/imagesnew/about-bg-img.jpg");
  background-repeat: no-repeat;
}
@media only screen and (min-width: 991px) {
  .header-container{
    background-size: 44% 80%;
    background-position: bottom right;
  }
}
@media only screen and (max-width: 991px) {
  .header-container{
    background-size: 35% 35%;
    background-position: bottom right;
  }
}


</style>
